import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getDateMinMessage,
    getReqMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const MAX_COMPANY_NAME = 200;
export const MAX_DESCRIPTION_LENGTH = 2000;
export const MAX_JOB_TITLE = 100;

export const validate = (newEntry, initialStateOnEntry) => {
    return checkDiff(newEntry, initialStateOnEntry);
};

export const validateEdit = (newEntry, initialStateOnEntry, type) => {
    let newErrors = {};

    if (!newEntry.companyName) {
        newErrors = {
            ...newErrors,
            companyName: {
                error: true,
                message: getReqMessage('Company name')
            }
        };
    }

    if (!newEntry.employmentTypeId) {
        newErrors = {
            ...newErrors,
            employmentTypeId: {
                error: true,
                message: getSelectMessage('employment type', 'an')
            }
        };
    }

    if (!newEntry.jobTitle) {
        newErrors = {
            ...newErrors,
            jobTitle: {
                error: true,
                message: getReqMessage('Job title')
            }
        };
    }

    if (newEntry.endDate && newEntry.endDate < newEntry.startDate) {
        newErrors = {
            ...newErrors,
            endDate: {
                error: true,
                message: getDateMinMessage('start date')
            }
        };
    }

    if (type === 'edit' && Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialStateOnEntry);

    return newErrors;
};
